import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';
import { getIsApmERPJobFlow } from 'lib/selectors/getIsApmERPJobFlow';

export const getIsInitialActivitySetPollLoading = (state) => {
  // In NATS mode, we don't wait for activity set polling - labor ticket is source of truth
  const natsFlowEnabled = getPostLaborUpdatesOnNats(state);
  if (natsFlowEnabled) {
    return false;
  }
  // APM mode: opdash display manages current job, no activity set polling needed
  const isApmERPJobFlow = getIsApmERPJobFlow(state);
  if (isApmERPJobFlow) {
    return false;
  }
  return !!state.recentActivitySetsPoll.isInitialPollLoading;
};
